import b2bCopilotDevPlanMarkdown from '@/assets/Artifacts/b2b-copilot-dev-plan.md?raw'
import { buildStepNarration } from './stepNarrationCopy.js'

export const B2B_COPILOT_PLAN_AI_LOG_STEPS_AFTER_WRITE = [
  {
    durationMs: 178000,
    actionName: 'Wrote file',
    arguments: {
      op: 'write',
      path: '/DOSense/agent/home/b2b-copilot-dev-plan.md',
      content: b2bCopilotDevPlanMarkdown,
    },
    result: { ok: true },
    status: 'ok',
    defaultExpanded: false,
    stepNarration: buildStepNarration(
      'The full development plan is saved as markdown',
      'opening it in the preview panel',
      2,
    ),
  },
  {
    durationMs: 1200,
    actionName: 'Loaded show_user_preview',
    arguments: {
      tools: [{ toolName: 'show_user_preview' }],
    },
    result: {
      status: 'loaded',
      tools: [{ connectionId: null, toolName: 'show_user_preview' }],
    },
    status: 'ok',
    defaultExpanded: false,
    stepNarration: buildStepNarration('Preview panel is ready', 'loading the rename chat tool', 3),
  },
  {
    durationMs: 4000,
    actionName: 'Loaded rename_chat',
    arguments: {
      tools: [{ toolName: 'rename_chat' }],
    },
    result: {
      status: 'loaded',
      tools: [{ connectionId: null, toolName: 'rename_chat' }],
    },
    status: 'ok',
    defaultExpanded: false,
    stepNarration: buildStepNarration(
      'Rename chat is loaded',
      'titling this thread B2B AI Copilot Dev Plan',
      4,
    ),
  },
  {
    durationMs: 400,
    actionName: 'Chat renamed.',
    arguments: {
      toolName: 'rename_chat',
      args: { new_title: 'B2B AI Copilot Dev Plan' },
    },
    result: { message: 'Chat renamed to: "B2B AI Copilot Dev Plan"' },
    status: 'ok',
    defaultExpanded: false,
    stepNarration: buildStepNarration(
      'This chat is now titled B2B AI Copilot Dev Plan',
      'summarizing the plan highlights for you',
      0,
    ),
  },
]

/** @deprecated Use INITIAL + AFTER_WRITE; kept for step-count tests */
